const LedgerHeader = ({ children }) => {
  return (
    <div className="py-5 px-4 border-b border-gray-200">
      {children}
    </div>
  );
};

export default LedgerHeader;
